<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group">
                <label>ANNO</label>
                <select class="form-control form-control-sm" v-model="search.ANNO_PROTOCOLLO.VALUE">
                    <option value="">Qualsiasi</option>
                    <option v-for="anno in this.anni" v-bind:value="anno" v-bind:key="anno">
                    {{ anno }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>NUMERO</label><br>
                <input class="form-control form-control-sm" autocomplete="off" placeholder="Numero" type="text" style="width:100px" v-model="search.NUMERO_PROTOCOLLO.VALUE">
            </div>
            <div class="form-group">
                <label>TIPO</label>
                <select class="form-control form-control-sm" v-model="search.TIPO.VALUE">
                    <option value="">Tutti</option>
                    <option value="0">Entrata</option>
                    <option value="1">Uscita</option>
                </select>
            </div>
            <div class="form-group ">
                <label>NOTE</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Titolo" type="text" style="width:200px" v-model="search.NOTE.VALUE">
            </div>
            <button v-if="false" class="btn btn-success float-right my-2 my-sm-3 mt-4 btn-sm" v-on:click="caricaAllegato()"><i class="fas fa-plus"></i> Nuovo Protocollo</button>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #a9a9a9;color:#fff">
                    <th  style="width:5%"><span >ID</span></th>
                    <th  style="width:5%"><span >ANNO</span></th>
                    <th  style="width:5%"><span >NUMERO</span></th>
                    <th  style="width:10%"><span >TIPO</span></th>
                    <th  style="width:25%"><span >NOME FILE</span></th>
                    <th  style="width:10%"><span >DATA CARICAMENTO</span></th>
                    <th  style="width:25%"><span >NOTE</span></th>
                    <th  style="width:15%"><span >AZIONI</span></th>
                    
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="protocollo.ID_ALLEGATO"  v-for="protocollo in paginatedList.arr">                        
                    <td  style="width:5%;font-size:16px">
                        {{ protocollo.ID_ALLEGATO }}
                    </td>
                    <td  style="width:5%">
                        {{ protocollo.ANNO_PROTOCOLLO }}
                    </td>
                    <td  style="width:5%">
                        {{ protocollo.NUMERO_PROTOCOLLO }}
                    </td>
                    <td  style="width:10%">
                        <span v-if="protocollo.TIPO" class='badge badge-info'>USCITA</span>
                        <span v-if="protocollo.TIPO == 0" class='badge badge-primary'>ENTRATA</span>                      
                    </td>          
                    <td  style="width:25%">
                        {{ protocollo.NOME_FILE }}
                    </td>
                    <td  style="width:10%">
                        {{filters.formatDate(protocollo.DATA_CARICAMENTO)}}
                    </td>
                    <td  style="width:25%">
                        {{ protocollo.NOTE }}
                    </td>
                    <td style="width:15%">
                        <button v-on:click="openAllegato(protocollo.ID_ALLEGATO)" class="btn btn-info btn-sm float-right" title="Scarica allegato"><i class="fas fa-download"></i></button>
                        <button v-on:click="modificaProtocollo(protocollo)" class="btn btn-warning btn-sm float-right mr-1" title="Modifica protocollo"><i class="fas fa-pencil-alt"></i></button>
                        <button v-on:click="openLogProtocollo(protocollo)" class="btn btn-secondary btn-sm float-right mr-1" title="Storico modifiche"><i class="fas fa-history"></i></button>
                    </td>
                    
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>

    <div class="modal fade" :id="'popUpAllegato'+ts" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header" style="background:#629991">
                    <h4 style="color:#fff" class="modal-title"><i class="fas fa-paperclip fa-fw"></i> Allegato</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:550px">
                    <div class="row">
                        <div class="col-6">
                            <form>
                                <div class="form-group">
                                    <label >Note</label>
                                    <textarea class="form-control form-control-sm" rows="11" placeholder="Inserisci le tue note qui..." v-model="argsUpload.NOTE"></textarea>
                                </div>
                                <div class="form-group col-md-12">
                                    <label >Genera contestualmente numero protocollo</label>
                                    <input class="form-control form-control-sm" style="width:20px;height:20px" type="checkbox" v-model="argsUpload.FLG_ASSEGNA_PROTOCOLLO" v-bind:true-value="1" v-bind:false-value="0">
                                </div>
                                <div v-if="argsUpload.FLG_ASSEGNA_PROTOCOLLO" class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Tipologia</label>
                                    <select class="form-control " v-model="argsUpload.TIPO">
                                        <option value="0">ENTRATA</option>
                                        <option value="1">USCITA</option>
                                    </select>
                                </div> 
                            </form>
                        </div>
                        <div class="col-6">
                            <Upload @onsuccess="successCaricamento()" :w="90" :args="argsUpload"></Upload>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpModificaProtocollo'+ts" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" style="min-width:900px;">
            <div class="modal-content">
                <div class="modal-header" style="background:#0597F2;">
                    <h4 style="color:#fff" class="modal-title">
                        <i class="fas fa-stamp fa-fw mr-1"></i> Modifica Protocollo N. {{ protocolloSelezionato.NUMERO_PROTOCOLLO }} / {{ protocolloSelezionato.ANNO_PROTOCOLLO }}
                    </h4>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="row">
                                <div class="form-group col-6">
                                    <label class="font-weight-bold">ANNO</label>
                                    <input type="text" class="form-control form-control-sm" :value="protocolloSelezionato.ANNO_PROTOCOLLO" disabled readonly>
                                </div>
                                <div class="form-group col-6">
                                    <label class="font-weight-bold">NUMERO</label>
                                    <input type="text" class="form-control form-control-sm" :value="protocolloSelezionato.NUMERO_PROTOCOLLO" disabled readonly>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold">Tipo *</label>
                                <select class="form-control form-control-sm" v-model="protocolloSelezionato.TIPO">
                                    <option value="0">ENTRATA</option>
                                    <option value="1">USCITA</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold">Note</label>
                                <textarea class="form-control form-control-sm" rows="6" placeholder="Inserisci note..." v-model="protocolloSelezionato.NOTE"></textarea>
                            </div>
                            <div class="alert alert-light border">
                                <small class="text-muted d-block font-weight-bold mb-1">File attualmente associato:</small>
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="text-truncate mr-2"><i class="fal fa-file-alt mr-1"></i><strong>{{ protocolloSelezionato.NOME_FILE }}</strong></span>
                                    <button type="button" class="btn btn-sm btn-info" v-on:click="openAllegato(protocolloSelezionato.ID_ALLEGATO)" title="Scarica file attuale">
                                        <i class="fas fa-download"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="font-weight-bold mb-1">Sostituisci File</label>
                            <p class="text-muted small">Trascina o seleziona un file per sostituire il documento:</p>
                            <Upload @onsuccess="successModificaFile()" :w="85" :args="argsUploadModifica"></Upload>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary mr-auto" v-on:click="openLogProtocollo(protocolloSelezionato)"><i class="fas fa-history mr-1"></i> Storico modifiche</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Annulla</button>
                    <button type="button" class="btn btn-primary" v-on:click="salvaModificaProtocollo()"><i class="fas fa-save mr-1"></i> Salva modifiche</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpLogProtocollo'+ts" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header" style="background:#4A5568;">
                    <h4 style="color:#fff" class="modal-title">
                        <i class="fas fa-history fa-fw mr-1"></i> Storico Modifiche Protocollo N. {{ protocolloLogSelezionato.NUMERO_PROTOCOLLO }} / {{ protocolloLogSelezionato.ANNO_PROTOCOLLO }}
                    </h4>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="max-height:500px; overflow-y:auto;">
                    <div v-if="loadingLog" class="text-center py-4">
                        <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
                        <p class="text-muted mt-2">Caricamento storico in corso...</p>
                    </div>
                    <div v-else-if="!logSelezionato || logSelezionato.length === 0" class="alert alert-light border text-center text-muted my-3">
                        <i class="fal fa-info-circle fa-2x d-block mb-2"></i>
                        Nessun evento o modifica registrata per questo protocollo.
                    </div>
                    <div v-else class="timeline mt-2">
                        <div class="timeline-item" v-for="azione in logSelezionato" :key="azione.ID_AZIONE">
                            <div class="timeline-item-marker">
                                <div class="timeline-item-marker-text" style="width:142px;color:#000;font-weight:bold;">{{ filters.formatDateTime(azione.DATA_AZIONE) }}</div>
                                <div class="timeline-item-marker-indicator bg-primary-soft text-primary" style="border:1px solid"><i class="fal fa-comment"></i></div>
                            </div>
                            <div class="timeline-item-content pt-0 pb-3">
                                <div class="card shadow-sm">
                                    <div class="card-body py-2 px-3">
                                        <h6 class="mb-1" style="color:#62106e;font-weight:bold"><i class="fal fa-user mr-1"></i>{{ azione.USERNAME }}</h6>
                                        <div style="font-size:13px; color:#333;">{{ azione.DESCRIZIONE }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import Upload from '@/components/utils/Upload.vue'
import Pagine from '@/components/utils/Pagine.vue'


export default {
    name:"Protocollo",
    components:{
        Pagine,
        Upload
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                ANNO_PROTOCOLLO:{TYPE:'COMBO',VALUE:'2024'}, 
                NUMERO_PROTOCOLLO:{TYPE:'TEXT',VALUE:''},
                TIPO:{TYPE:'COMBO',VALUE:''},
                NOTE:{TYPE:'TEXT',VALUE:''},
            },        
        
            arrayProtocolli:new Array(),
            anni:new Array(),
            argsUpload : {modalita:'EMMET_uploadAllegato'},
            ts:new Date().getTime(),
            protocolloSelezionato:{},
            argsUploadModifica:{},
            protocolloLogSelezionato:{},
            logSelezionato:[],
            loadingLog:false,
        
        }
    },
    methods: {
        getProtocolli : function(){
            global.utils.get('/emmet/protocolli', { ordinamento: 'DESC' }, (response) => {       
                this.arrayProtocolli = (response.data || []).sort((a, b) => Number(b.ID_ALLEGATO) - Number(a.ID_ALLEGATO));
                for (var i=0; i<this.arrayProtocolli.length; i++){
                    if (!this.anni.includes(this.arrayProtocolli[i].ANNO_PROTOCOLLO)){
                        this.anni.push(this.arrayProtocolli[i].ANNO_PROTOCOLLO);
                    }
                }
                this.search.ANNO_PROTOCOLLO.VALUE  = new Date().getFullYear();
            });
        },
        openAllegato : function(idAllegato){
            window.open(global.utils.BASE_API + "core/report?ID_REPORT=1001&ID_ALLEGATO="+idAllegato+"&SESSION_TOKEN="+utils.SESSION_TOKEN);
        },
        caricaAllegato : function(){
            this.argsUpload.FK_ID_PRATICA = 0;
            this.argsUpload.NOTE = "";
            this.argsUpload.FLG_ASSEGNA_PROTOCOLLO = 0;
            this.argsUpload.TIPO = 0;
            this.argsUpload.CATEGORIA = "";
            utils.openModal('popUpAllegato'+this.ts);
        },
        successCaricamento : function(){
            this.getProtocolli();
            utils.closeModal('popUpAllegato'+this.ts);
        },
        modificaProtocollo : function(protocollo){
            this.protocolloSelezionato = utils.clone(protocollo);
            this.argsUploadModifica = this.protocolloSelezionato;
            this.argsUploadModifica.modalita = 'EMMET_modificaProtocollo';
            utils.openModal('popUpModificaProtocollo' + this.ts);
        },
        salvaModificaProtocollo : function(){
            global.utils.post('/emmet/protocollo/modifica', {
                ID_ALLEGATO: this.protocolloSelezionato.ID_ALLEGATO,
                TIPO: this.protocolloSelezionato.TIPO,
                NOTE: this.protocolloSelezionato.NOTE
            }, (response) => {
                if (response.esito == 0){
                    global.utils.alert.success("Protocollo modificato con successo");
                    utils.closeModal('popUpModificaProtocollo' + this.ts);
                    this.getProtocolli();
                }
            });
        },
        successModificaFile : function(){
            global.utils.alert.success("File e protocollo aggiornati con successo");
            utils.closeModal('popUpModificaProtocollo' + this.ts);
            this.getProtocolli();
        },
        openLogProtocollo : function(protocollo){
            this.protocolloLogSelezionato = protocollo;
            this.logSelezionato = [];
            this.loadingLog = true;
            utils.openModal('popUpLogProtocollo' + this.ts);
            global.utils.get('/emmet/allegato/log', { ID_ALLEGATO: protocollo.ID_ALLEGATO }, (response) => {
                this.loadingLog = false;
                this.logSelezionato = response.data || [];
            });
        },
        
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayProtocolli,this.search);
            return arr;
        }, 
    },
    created : function(){
       this.getProtocolli(); 
    },

}


</script>
